export enum ROLES {
  ADMIN = 'Admin',
  ADVANCED = 'Advanced / Power User',
  VIEWER = 'View Only (Viewer)',
  COMMISSIONER = 'Commissioner/Integrator',
}

export enum EVENT_CATEGORY {
  CRITICAL = 'Critical Events',
  INFORMATION = 'Information Events',
  SYSTEM = 'System Events',
}

export enum LICENSE_TYPE {
  MULTITENANT = 'Multi-Tenant',
}

export const ROLES_SORTING_ORDER = {
  [ROLES.ADMIN]: 0,
  [ROLES.ADVANCED]: 1,
  [ROLES.VIEWER]: 2,
  [ROLES.COMMISSIONER]: 3,
};

export enum ACTIONS {
  VIEW = 'view',
  EDIT = 'edit',
  DELETE = 'delete',
}

export enum USER_ACTION {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  DUPLICATE = 'DUPLICATE',
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT'
}

export enum PAGE {
  DASHBOARD = 'Dashboard',
  PROPERTY = 'Property',
  USER = 'User',
  DEVICE = 'Device',
  ALARM = 'Alarm',
  AUTOMATION = 'Automation',
  REPORT = 'Report',
  GROUP = 'Group',
  CONTRACT = 'Contract',
  WIDGET = 'Widget',
  CONTROL = 'Control',
  REFRESH_DASHBOARD = 'Refresh Dashboard',
  LOGON = 'Logon'
}
